import api from "@/api/marketing/cpl";
import moment from 'moment';

const state = () => ({

  cplLeads: [],
  cplLeadsLoading: false,
  cplLeadsError: null,
  cplLeadsErrorResponse: '',

  numberOfCplLeads: 0,

  filters: {
    kind: [],
    source: [],
    status: [],
    added: moment(new Date()).format('YYYY-MM-DD'),
    sold: null,
    hideCompleted: true,
  },
  
  filterItems: {
    kind: [
      {text: 'VoIP', value: 'VOIP'},
      {text: 'Telco', value: 'TELCO'},
      {text: 'Website', value: 'WEB'},
    ],
    source: [
      {text: 'Inbound', value: 'INBOUND'},
      {text: 'Outbound', value: 'OUTBOUND'},
    ],
    status: [
      {text: 'Live', value: 'Live'},
      {text: 'Cold', value: 'Cold'},
      {text: 'Warm', value: 'Warm'},
    ],
  },

  statusesLoading: false,
  statusesError: null,
  statusesErrorResponse: '',

  sourcesLoading: false,
  sourcesError: null,
  sourcesErrorResponse: '',

  setCplLoading: false,
  setCplError: null,
  setCplErrorResponse: [],

});

const mutations = {

  FETCH_CPL_LEADS_BEGIN(state){
    state.cplLeadsLoading = true;
    state.cplLeadsError = null;
    state.cplLeadsErrorResponse = '';
  },
  FETCH_CPL_LEADS_SUCCESS(state,res){
    state.cplLeads = res.data.map(e=>({...e,selected:false}));
    state.numberOfCplLeads = res.headers['pagination-count'];
    state.cplLeadsLoading = false;
    state.cplLeadsError = null;
    state.cplLeadsErrorResponse = '';
  },
  FETCH_CPL_LEADS_FAILED(state,error){
    state.cplLeadsLoading = false;
    state.cplLeadsError = true;
    state.cplLeadsErrorResponse = error;
  },

  FETCH_STATUSES_BEGIN(state){
    state.statusesLoading = true;
    state.statusesError = null;
    state.statusesErrorResponse = '';
  },
  FETCH_STATUSES_SUCCESS(state,data){
    state.filterItems.status = data;
    state.statusesLoading = false;
    state.statusesError = null;
    state.statusesErrorResponse = '';
  },
  FETCH_STATUSES_FAILED(state,error){
    state.statusesLoading = false;
    state.statusesError = true;
    state.statusesErrorResponse = error;
  },

  FETCH_SOURCES_BEGIN(state){
    state.sourcesLoading = true;
    state.sourcesError = null;
    state.sourcesErrorResponse = '';
  },
  FETCH_SOURCES_SUCCESS(state,data){
    state.filterItems.source = data.map(item => ({ text: item, value: item }));
    state.sourcesLoading = false;
    state.sourcesError = null;
    state.sourcesErrorResponse = '';
  },
  FETCH_SOURCES_FAILED(state,error){
    state.sourcesLoading = false;
    state.sourcesError = true;
    state.sourcesErrorResponse = error;
  },

  SET_CPL_BEGIN(state){
    state.setCplLoading = true;
    state.setCplError = null;
    state.setCplErrorResponse = [];
  },
  SET_CPL_SUCCESS(state){
    state.setCplLoading = false;
    state.setCplError = null;
    state.setCplErrorResponse = [];
  },
  SET_CPL_FAILED(state,error){
    state.setCplLoading = false;
    state.setCplError = true;
    state.setCplErrorResponse.push(error);
  },

  SET_FILTER(state,data){
    state.filters[data.key] = data.value;
  },

  SELECT_ALL_FOR_CPL(state){
    state.cplLeads.forEach(e => { e.selected = true; } );
  },

  DESELECT_ALL_FOR_CPL(state){
    state.cplLeads.forEach(e => { e.selected = false; } );
  },

};

const actions = {

  async fetchCplLeads( {commit,dispatch,state} ){
    commit('FETCH_CPL_LEADS_BEGIN');
    try{
      const res = await api.fetchCplLeads(state.filters);
      if(res.status===200){
        commit('FETCH_CPL_LEADS_SUCCESS',res);
      }else{
        commit('FETCH_CPL_LEADS_FAILED',res.response.data.message);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('FETCH_CPL_LEADS_FAILED',err.response.data.message);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },

  async setCpl( {commit,dispatch}, data ){
    commit('SET_CPL_BEGIN');
    const res = await api.setCPL(data);
    const hasError = res.map(e=>e.success);
    
    if(hasError.includes(false)){

      const errors = res.filter(e=>!e.success).map(e=>`${e.lead_id}: ${e.message}`);
      dispatch("alerts/setAlert", {type:"error",message: errors.join('<br/>')}, { root: true });
      commit('SET_CPL_FAILED');

      if(hasError.includes(true)){ dispatch('fetchCplLeads'); }
      
    }else{
      
      const lead_ids = res.filter(e=>e.success).map(e=>`${e.lead_id}`);
      dispatch("alerts/setAlert", {type: "success",message: `Successfully set CPL for: ${lead_ids.join(', ')}`}, { root: true });
      dispatch('fetchCplLeads');
      dispatch('fetchSources');
      commit('SET_CPL_SUCCESS');

    }

  },

  async fetchStatuses( {commit,dispatch} ){
    commit('FETCH_STATUSES_BEGIN');
    try{
      const res = await api.fetchStatusFilters();
      if(res.status===200){
        commit('FETCH_STATUSES_SUCCESS',res.data);
      }else{
        commit('FETCH_STATUSES_FAILED',res.response.data.message);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('FETCH_STATUSES_FAILED',err.response.data.message);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },

  async fetchSources( {state,commit,dispatch} ){
    commit('FETCH_SOURCES_BEGIN');
    try{
      const res = await api.fetchSourceFilters(state.filters);
      if(res.status===200){
        commit('FETCH_SOURCES_SUCCESS',res.data);
      }else{
        commit('FETCH_SOURCES_FAILED',res.response.data.message);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('FETCH_SOURCES_FAILED',err.response.data.message);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  
  setFilterFetchLead({commit,dispatch},data){
    commit('SET_FILTER',data);
    dispatch('fetchCplLeads');
    dispatch('fetchSources');
  },
  
  selectAllForCPL({commit}){
    commit('SELECT_ALL_FOR_CPL');
  },
  
  deselectAllForCPL({commit}){
    commit('DESELECT_ALL_FOR_CPL');
  },

};

const getters = {

  getCplLeads: state => state.cplLeads,
  getNumberOfCplLeads: state => state.numberOfCplLeads,

  getSelectedCplLeads: state => state.cplLeads.filter(e=>e.selected),
  getSelectedCplLeadIds: state => state.cplLeads.filter(e=>e.selected).map(e=>e.id),
  getCplLeadsLoading: state => state.cplLeadsLoading,
  getCplLeadsError: state => state.cplLeadsError,
  getCplLeadsErrorResponse: state => state.cplLeadsErrorResponse,

  getAllFilters: state => state.filters,
  getFilterByType: state => type => state.filters[type],

  getAllFilterItems: state => state.filterItems,
  getFilterItemsByType: state => type => state.filterItems[type].map(e=>e.value).filter(e=>e),

  getStatusesLoading: state => state.statusesLoading,
  getStatusesError: state => state.statusesError,
  getStatusesErrorResponse: state => state.statusesErrorResponse,

  getSourcesLoading: state => state.sourcesLoading,
  getSourcesError: state => state.sourcesError,
  getSourcesErrorResponse: state => state.sourcesErrorResponse,

  getSetCplLoading: state => state.setCplLoading,
  getSetCplError: state => state.setCplError,
  getSetCplErrorResponse: state => state.setCplErrorResponse,

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  